import { FormattedMessage } from '@alltrails/shared/react-intl';
import isEqual from 'underscore/modules/isEqual';
import { getLines } from '@alltrails/maps/utils/legacyGeoJSONConversions';
import { getMapDistance } from '../../../../utils/at_map_helpers';
import { saveAtMap } from '../../../../utils/requests/at_map_requests';

const createReactClass = require('create-react-class');

const VerifiedRouteContributeItem = createReactClass({
  getInitialState() {
    return {
      trailPlannerActive: false,
      showInstructions: false
    };
  },
  componentDidUpdate(prevProps) {
    // Has GPX been uploaded (/trail/new)?
    if (!isEqual(prevProps.mapModel, this.props.mapModel)) {
      this.disableTrailPlanner();
    }
  },
  componentWillUnmount() {
    this.props.messagingChannel.publish('edit.disable_trail_planner');
  },
  getDistance() {
    const { routeInfo, mapModel } = this.props;
    if (routeInfo) {
      return routeInfo.distance;
    }
    if (mapModel) {
      return getMapDistance(mapModel);
    }
    return 0;
  },
  isTrailNewWithGivenTrack() {
    return this.props.rapidRoute && !this.props.trail.id;
  },
  getVREditData(relationId) {
    return {
      type: 'verified_route',
      data: {
        display_text: this.formatDistance(),
        move_th_to_start_pt: 'Y',
        use_description: 'Y'
      },
      relation_id: relationId
    };
  },
  getNewEditData() {
    if (!this.state.trailPlannerActive && this.props.mapModel) {
      const defaultMap = this.props.trail.defaultMap;
      if (!defaultMap || defaultMap.id !== this.props.mapModel.id || this.isTrailNewWithGivenTrack()) {
        // If user uploaded a GPX, no need to create map before creating edit item.
        return this.getVREditData(this.props.mapModel.id);
      }
    }

    if (this.state.trailPlannerActive && this.getDistance() > 0.0 && this.props.routeInfo.hasChanged) {
      // Use the itemPostHandler callback option rather than returning an edit item.
      // This allows us to save the map, then save the edit item with the new map id,
      // without creating a synchronous block on the main JS thread.
      // Need to capture the route JSON now, because the map object holding it may not
      // be valid when the callback is called (race condition, story 103039636)
      const map = this.retainOriginalMapData(this.props.routeInfo.plannerMap, this.props.trail.defaultMap);
      return {
        itemPostHandler: this.itemPostHandler,
        itemPostHandlerData: { map }
      };
    }

    return null;
  },
  retainOriginalMapData(newMap, originalMap) {
    // Carry over specific, non-route-line data from the original map into the new one
    if (!originalMap) {
      return newMap;
    }
    const { description, rating, waypoints } = originalMap;
    return { description, rating, waypoints, ...newMap };
  },
  itemPostHandler(itemUrl, editItem, postEditItem, itemPostHandlerData) {
    const { map } = itemPostHandlerData;
    map.status = 'P';
    map.trail_id = this.props.trail.id;

    saveAtMap(map, { system_owned: 'true', detail: 'lite' })
      .then(newMap => {
        postEditItem(itemUrl, this.getVREditData(newMap.id));
      })
      .catch(e => {
        console.error('Map save failed: ', e);
      });
  },
  disableTrailPlanner() {
    if (this.state.trailPlannerActive) {
      this.props.messagingChannel.publish('edit.disable_trail_planner');
      this.setState({ trailPlannerActive: false, showInstructions: false });
    }
  },
  enableTrailPlanner(loadVerifiedRoute) {
    if (!this.state.trailPlannerActive) {
      // Get single route to load into trail planner on init (from GPX upload or editing existing verifie route)
      let route;
      if (loadVerifiedRoute && this.props.mapModel) {
        const routes = getLines(this.props.mapModel);
        if (routes.length > 0) {
          route = routes[0];
        }
      }
      // Enable and show instruction block briefly
      this.props.messagingChannel.publish('edit.enable_trail_planner', route);
      this.setState({ trailPlannerActive: true, showInstructions: true });
      setTimeout(() => {
        this.setState({ showInstructions: false });
      }, 30000); // 30 seconds
    }
  },
  handleEditClick() {
    this.enableTrailPlanner(true);
  },
  handleDrawClick() {
    this.enableTrailPlanner(false);
  },
  handleOutAndBackClick() {
    this.props.messagingChannel.publish('button.click.out_and_back');
  },
  handleReturnClick() {
    this.props.messagingChannel.publish('button.click.return');
  },
  handleReverseRouteClick() {
    this.props.messagingChannel.publish('button.click.reverse');
  },
  formatDistance(distance) {
    if (!distance) {
      distance = this.getDistance();
    }
    if (this.props.displayMetric) {
      return `Len: ${(distance > 0.0 ? distance / 1000.0 : 0.0).toFixed(1)}km`;
    }
    return `Len: ${(distance > 0.0 ? distance / 1609.344 : 0.0).toFixed(1)}mi`;
  },
  renderCancelButton() {
    if (this.props.trail.id || this.isTrailNewWithGivenTrack()) {
      return (
        <button className="option-button" onClick={this.disableTrailPlanner}>
          <FormattedMessage defaultMessage="Cancel" />
        </button>
      );
    }
    return null;
  },
  renderOutAndBackButton() {
    return (
      <button
        className="option-button"
        disabled={!this.props.routeInfo || !this.props.routeInfo.rtsAvailable}
        onClick={this.handleOutAndBackClick}
        data-testid="outAndBackContribute"
        title={this.props.intl.formatMessage({ defaultMessage: 'Return back the same way' })}
      >
        <FormattedMessage defaultMessage="Double-back" />
      </button>
    );
  },
  renderReturnButton() {
    return (
      <button
        className="option-button"
        disabled={!this.props.routeInfo || !this.props.routeInfo.rtsAvailable}
        onClick={this.handleReturnClick}
        title={this.props.intl.formatMessage({ defaultMessage: 'Return back the shortest way' })}
      >
        <FormattedMessage defaultMessage="Close loop" />
      </button>
    );
  },
  renderReverseButton() {
    return (
      <button
        className="option-button"
        disabled={false}
        onClick={this.handleReverseRouteClick}
        title={this.props.intl.formatMessage({ defaultMessage: 'Switch your start and end points' })}
      >
        <FormattedMessage defaultMessage="Reverse" />
      </button>
    );
  },
  renderEditRouteButton() {
    return (
      <button className="option-button" onClick={this.handleEditClick} title={this.props.intl.formatMessage({ defaultMessage: 'Edit route' })}>
        <FormattedMessage defaultMessage="Edit route" />
      </button>
    );
  },
  renderDrawRouteButton(className = 'option-button') {
    return (
      <button
        className={className}
        onClick={this.handleDrawClick}
        title={this.props.intl.formatMessage({ defaultMessage: 'Draw route' })}
        data-testid="draw-route"
      >
        <FormattedMessage defaultMessage="Draw route" />
      </button>
    );
  },
  renderButtons() {
    const buttonsClasses = 'option-button-group';
    if (this.state.trailPlannerActive) {
      return (
        <div className={buttonsClasses}>
          {this.renderCancelButton()}
          {this.renderOutAndBackButton()}
          {this.renderReturnButton()}
          {this.renderReverseButton()}
          <br />
          <span>{this.formatDistance()}</span>
        </div>
      );
    }
    return (
      <div className={buttonsClasses}>
        {this.renderDrawRouteButton()}
        {this.renderEditRouteButton()}
      </div>
    );
  },
  renderInstructions() {
    return (
      <div id="verified-route-instructions" className={this.state.showInstructions ? '' : 'hidden'}>
        <FormattedMessage
          defaultMessage="When adding new trails, we are specifically looking for trails that start and end at a parking area and are on public property. Our strong preference is for out-and-back or loop trails that begin and end in the same location, but of course some trails are through trails and they are welcome too. Please note that any suggested trail additions must first be evaluated by our moderators. This process may take a while depending on our ability to verify the information. To read more about how to draw a route click <a>here</a>."
          values={{
            a: linkText => (
              <a target="_blank" href="https://alltrails.zendesk.com/knowledge/articles/360019245911/en-us?brand_id=360001491372">
                {linkText}
              </a>
            )
          }}
        />
      </div>
    );
  },
  render() {
    return (
      <div className="xlate-none">
        {this.renderButtons()}
        {this.renderInstructions()}
      </div>
    );
  }
});

export { VerifiedRouteContributeItem };
